import React from 'react';

export const SeparatorV2 = () => {
  return (
    <svg width="2" height="26" viewBox="0 0 2 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.850708 0L0.850709 25.43" stroke="url(#paint0_linear_2516_17212)"/>
      <defs>
        <linearGradient id="paint0_linear_2516_17212" x1="1.35071" y1="-2.18557e-08" x2="1.35071" y2="25.43" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0A0C23"/>
          <stop offset="0.496663" stopColor="#E1EFFF"/>
          <stop offset="1" stopColor="#0A0C23"/>
        </linearGradient>
      </defs>
    </svg>
  );
}